import MessagePopupView from '../controls/MessagePopupView.js';

class EmptyScreenUI {

    static showEmptyScreenMessages($parent, message) {
        if (!$parent || !$parent.length) {
            return false;
        }

        this.hideEmptyScreenMessages($parent);

        const msg = new MessagePopupView({
            addClass: 'info empty-screen-message',
            message: message,
            mask: false,
            dismissFromClick: false,
            dismissFromMask: false,
            dismissFromMessage: false,
            dismissFromEscape: false,
            dismissFromAnyKey: false,
            hasCloseButton: false,
            takeFocus: false
        });

        $parent.data('empty-message', msg);

        msg.show($parent);

        return true;
    }

    static hideEmptyScreenMessages($parent) {
        if (!$parent || !$parent.length) {
            return false;
        }

        const msg = $parent.data('empty-message');
        if (msg) {
            msg.remove();
        }
        $parent.removeData('empty-message');

        return true;
    }
}

export default EmptyScreenUI;